var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('vue-headful',{attrs:{"title":_vm._f("formatTitle")(_vm.$t('TITLE_TYPE', { type: _vm.$tc('SUBJECT', 2) }))}}),_vm._v(" "),_c('subject-list'),_vm._v(" "),_c('article',{staticClass:"subjects__route"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }